export default __webpack_public_path__ + "./images/ca.4a1d7a14.png";